import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/harvests/broth")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
